import { createContext, useContext, useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import HomePage from './pages/HomePage.jsx';
import InstructorsPage from './pages/InstructorsPage.jsx';
import SchedulePage from './pages/SchedulePage.jsx';
import LocationPage from './pages/LocationPage.jsx';
import PricingPage from './pages/PricingPage.jsx';
import ContactPage from './pages/ContactPage.jsx';
import RegisterPage from './pages/RegisterPage.jsx';
import AdminPage from './pages/AdminPage.jsx';

const ContentContext = createContext(null);

export function useContent() {
  return useContext(ContentContext);
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function LoadingScreen() {
  return (
    <div className="loading-screen" role="status">
      <img src="/media/pocono-logo.png" alt="Pocono Workshop" />
      <span>Preparing the workshop…</span>
    </div>
  );
}

export default function App() {
  const [content, setContent] = useState(null);
  const [error, setError] = useState('');

  const refreshContent = async () => {
    const response = await fetch('/api/content');
    if (!response.ok) throw new Error('The site content could not be loaded.');
    setContent(await response.json());
  };

  useEffect(() => {
    refreshContent().catch((loadError) => setError(loadError.message));
  }, []);

  if (error) return <div className="error-page"><h1>We hit a snag.</h1><p>{error}</p></div>;
  if (!content) return <LoadingScreen />;

  return (
    <ContentContext.Provider value={{ content, refreshContent }}>
      <ScrollToTop />
      <Routes>
        <Route path="/admin" element={<AdminPage />} />
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="instructors" element={<InstructorsPage />} />
          <Route path="schedule" element={<SchedulePage />} />
          <Route path="location" element={<LocationPage />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route path="*" element={<div className="not-found"><p className="eyebrow">404</p><h1>That page took the wrong turn.</h1><a className="button button-dark" href="/">Back home</a></div>} />
        </Route>
      </Routes>
    </ContentContext.Provider>
  );
}
